import { IPropertyConverter, TaJson } from "ta-json";

import { JsonValue } from "../base-types";
import { InvalidOperationError } from "../errors/invalid-operation-error";
import { FacetResponseResource } from "../models/search/facet-response-resource";

export class AllFacetValuesChildrenConverter implements IPropertyConverter {
    /**
     * Serializes a mapping of strings to array of FacetResponseResource into a JSON object.
     *
     * @param value - A mapping of strings to array of FacetResponseResource
     *
     * @returns The serialized value.
     */
    serialize(children: Record<string, Array<FacetResponseResource>>): JsonValue {
        const result = Object.keys(children).reduce(
            (serialized: Record<string, Array<JsonValue>>, key: string) => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                const entries = children[key]?.map(entry => TaJson.serialize(entry));

                return { ...serialized, [key]: entries };
            },
            {} as Record<string, Array<JsonValue>>
        );

        return result;
    }

    /**
     * Deserializes a JSON object into a mapping of strings to array of FacetResponseResource.
     *
     * @param value - The serialized value
     *
     * @returns A mapping of strings to array of FacetResponseResource.
     */
    deserialize(value: Record<string, Array<JsonValue>>): Record<string, Array<FacetResponseResource>> {
        if (!value) {
            return {};
        } else if (typeof value !== "object") {
            throw new InvalidOperationError(
                `Expected a value of type 'JSON object', but value was of type '${typeof value}'.`
            );
        }

        const result = Object.keys(value).reduce(
            (current: Record<string, Array<FacetResponseResource>>, key: string) => {
                const entries = value[key]?.map(entry =>
                    TaJson.deserialize<FacetResponseResource>(entry, FacetResponseResource)
                );

                return { ...current, [key]: entries };
            },
            {}
        );

        return result;
    }
}
